module.exports = __webpack_public_path__ + "img/scroll-top.303efc58.png";